
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/security-policy",
      function () {
        return require("private-next-pages/en/legal/security-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/legal/security-policy"])
      });
    }
  